<template>
  <CenteredContainer>
    <SfHeading
      class="sf-heading--left m-b-20"
      :level="2"
      :title="$t('New Password')"
    />
    <form class="form" @submit.prevent="setPassword">
      <SfInput
        v-model="password"
        name="password"
        :label="$t('Password')"
        type="password"
        class="form__element"
        :has-show-password="true"
        required
        minlength="6"
        :valid="confirmPasswordValid"
      />
      <SfInput
        v-model="confirmPassword"
        name="confirm-password"
        :label="$t('Confirm Password')"
        type="password"
        class="form__element"
        :has-show-password="true"
        required
        minlength="6"
        :valid="confirmPasswordValid"
        :error-message="$t('Password not match')"
      />
      <SfButton type="submit" class="sf-button--full-width form__submit">
        {{ $t('Reset Password') }}
      </SfButton>
    </form>
    <SfButton @click="goToLogin" class="sf-button--text action-button">
      {{ $t('Return to log in') }}
    </SfButton>
  </CenteredContainer>
</template>
<script>
import {
  SfInput,
  SfButton,
  SfHeading,
} from '@storefront-ui/vue';
import { Base64 } from 'js-base64';

import user from '../mixins/user';
import CenteredContainer from '../components/CenteredContainer.vue';

export default {
  name: 'ForgotPasswordConfirm',
  mixins: [user],
  components: {
    SfInput,
    SfButton,
    SfHeading,
    CenteredContainer,
  },
  data() {
    return {
      password: '',
      confirmPassword: '',
      confirmPasswordValid: true,
    };
  },
  methods: {
    setPassword() {
      if (this.password !== this.confirmPassword) {
        this.confirmPasswordValid = false;
        return;
      }

      this.confirmPasswordValid = true;

      this.forgotPasswordConfirm({
        email: this.$route.query.email,
        NewPassword: Base64.encode(this.password),
        ConfirmNewPassword: Base64.encode(this.confirmPassword),
        token: this.$route.query.token,
      })
        .then(() => {
          this.goToLogin();
        });
    },
    goToLogin() {
      this.$router.push('/login');
    },
  },
};
</script>
<style lang="scss" scoped>
.form {
  width: 100%;
  &__element {
    margin: var(--spacer-base) 0;
  }
  &__checkbox {
    margin: var(--spacer-xl) 0 var(--spacer-2xl) 0;
  }
  &__submit {
    margin: var(--spacer-xl) 0 0 0;
  }
}
.action-button {
  margin: var(--spacer-xl) 0;
}
</style>
